module.exports = __webpack_public_path__ + "media/smiles/liked_2-9566eb78.svg";